import { lazy } from 'react'
import StaffClocksLoader from './staff-clocks/loader'
import PunchesByStaffLoader from './punches-by-staff/loader'

export default {
  StaffClocks: {
    Component: lazy(() => import('./staff-clocks/StaffClocks.Page')),
    Loader: StaffClocksLoader,
  },
  PunchesByStaff: {
    Component: lazy(() => import('./punches-by-staff/PunchesByStaff.Page')),
    Loader: PunchesByStaffLoader,
  },
}
